/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
    const headerElement = document.querySelector('.header');
    const headerStickyClass = 'header-sticky';
    const headerHiddenClass = 'header--hidden';
    let lastScrollPosition = 0;

    if (!headerElement) {
        console.error("Header element not found. Check your selector.");
        return;
    }

    function handleScroll() {
        let currentScrollPosition = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);

        // Determine scroll direction
        const isScrollingDown = currentScrollPosition > lastScrollPosition;
        const isScrollingUp = currentScrollPosition < lastScrollPosition;

        // Update header state
        if (currentScrollPosition === 0) {
            headerElement.classList.remove(headerHiddenClass);
            body.classList.remove(headerStickyClass);
        } else if (isScrollingUp) {
            headerElement.classList.remove(headerHiddenClass);
            body.classList.add(headerStickyClass);
        } else if (isScrollingDown) {
            headerElement.classList.add(headerHiddenClass);
            body.classList.remove(headerStickyClass);
        }

        lastScrollPosition = currentScrollPosition; // Update last scroll position
    }

    // Attach scroll event listener
    window.addEventListener('scroll', handleScroll);
}
